import * as React from 'react';

import { cn } from '@/lib/utils';

const Input = React.forwardRef<HTMLInputElement, React.ComponentProps<'input'>>(
  ({ className, type, onWheel, ...props }, ref) => {
    return (
      <input
        type={type}
        className={cn(
          'flex h-10 w-full rounded-md border border-input bg-background px-3 py-2 text-base ring-offset-background file:border-0 file:bg-transparent file:text-sm file:font-medium file:text-foreground focus-visible:outline-hidden disabled:cursor-default md:text-sm',
          className,
        )}
        ref={ref}
        onWheel={(event) => {
          // Number inputs change their value when the wheel is scrolled while
          // focused. Blur on wheel so the amount stays put and the page scrolls
          // normally (preventDefault is unreliable here: React attaches wheel
          // listeners passively at the root).
          if (
            type === 'number' &&
            event.currentTarget === document.activeElement
          )
            event.currentTarget.blur();
          onWheel?.(event);
        }}
        {...props}
      />
    );
  },
);
Input.displayName = 'Input';

export { Input };
